export const WORKSHEET_FORM_ID = 'document-worksheet-form';

export const WORKSHEET_DRAWER_DEFAULT_TITLE = 'Worksheet';

export const WORKSHEET_SAVE_DRAFT_LABEL = 'Save';

export const WORKSHEET_COMPLETE_LABEL = 'Complete';

export const WORKSHEET_EMPTY_FIELDS_MESSAGE = 'At least one field must be filled in';

export const WORKSHEET_SAVE_SUCCESS_MESSAGE = 'Worksheet saved';

export const WORKSHEET_COMPLETE_SUCCESS_MESSAGE = 'Worksheet completed';

export const WORKSHEET_CALCULATION_DEBOUNCE_MS = 400;

export const WORKSHEET_RECALCULATION_FAILED_MESSAGE =
  'Worksheet saved, but its calculated values could not be updated';

export const WORKSHEET_PRINT_LABEL = 'Print';

export const WORKSHEET_PRINT_POPUP_BLOCKED_MESSAGE = 'Allow pop-ups to print the worksheet.';

export const WORKSHEET_PRINT_LOAN_FACTS_TITLE = 'Loan facts';

export const WORKSHEET_PRINT_ANSWERS_TITLE = 'Answers';

export const WORKSHEET_CALCULATED_VALUES_TITLE = 'Calculated values';

export const WORKSHEET_EMPTY_VALUE = '—';

export const WORKSHEET_PRINT_YES = 'Yes';

export const WORKSHEET_PRINT_NO = 'No';

// Group id of a saved table row (row 2 onward) when a reopened worksheet rebuilds its rows.
export const WORKSHEET_TABLE_ROW_GROUP_PREFIX = 'row';
